export const getNextMatchingSibling = (elem, selector) => {
  let sibling = elem.nextElementSibling

  if (!selector) {
    return sibling
  }

  while (sibling) {
    if (sibling.matches(selector)) {
      return sibling
    }
    sibling = sibling.nextElementSibling
  }
}

export const getPreviousMatchingSibling = (elem, selector) => {
  let sibling = elem.previousElementSibling

  if (!selector) {
    return sibling
  }

  while (sibling) {
    if (sibling.matches(selector)) {
      return sibling
    }
    sibling = sibling.previousElementSibling
  }
}

// turn a string into a valid slug, usable in html5 ids
// slugify :: String -> String
export const slugify = (string) =>
  String(string)
    .trim()
    .replace(/\s/g, '-') // turn spaces into slugs
    .replace(/-+/g, '-') // only one dash allowed
    .toLowerCase()
